export default __webpack_public_path__ + "static/media/reacthook.21f58cd3.jpeg";